import { getTheme } from "../../../graphic/theme";

import { LINE_NUMBER_TYPE } from "../../../graphic/constants";

import { fillVisible, runFill, runStroke, strokeVisible } from "./utils";

import { DefaultCanvasLineRender } from "./line-render";

import { drawIncrementalSegments } from "../../../common/render-curve";

export class DefaultIncrementalCanvasLineRender extends DefaultCanvasLineRender {
    constructor() {
        super(...arguments), this.numberType = LINE_NUMBER_TYPE;
    }
    drawShape(line, context, x, y, drawContext, params, fillCb, strokeCb) {
        if (line.incremental && drawContext.multiGraphicOptions) {
            const {startAtIdx: startAtIdx, length: length} = drawContext.multiGraphicOptions, {segments: segments = []} = line.attribute;
            if (startAtIdx > segments.length) return;
            const lineAttribute = getTheme(line).line, {fill: fill = lineAttribute.fill, stroke: stroke = lineAttribute.stroke, opacity: opacity = lineAttribute.opacity, fillOpacity: fillOpacity = lineAttribute.fillOpacity, strokeOpacity: strokeOpacity = lineAttribute.strokeOpacity, lineWidth: lineWidth = lineAttribute.lineWidth, visible: visible = lineAttribute.visible} = line.attribute, fVisible = fillVisible(opacity, fillOpacity, fill), sVisible = strokeVisible(opacity, strokeOpacity), doFill = runFill(fill), doStroke = runStroke(stroke, lineWidth);
            if (!line.valid || !visible) return;
            if (!doFill && !doStroke) return;
            if (!(fVisible || sVisible || fillCb || strokeCb)) return;
            const {context: context} = drawContext;
            for (let i = startAtIdx; i < startAtIdx + length; i++) this.drawIncreaseSegment(line, context, segments[i - 1], segments[i], line.attribute.segments[i], [ lineAttribute, line.attribute ], x, y);
        } else super.drawShape(line, context, x, y, drawContext, params, fillCb, strokeCb);
    }
    drawIncreaseSegment(line, context, lastSeg, seg, attribute, defaultAttribute, offsetX, offsetY) {
        seg && (context.beginPath(), drawIncrementalSegments(context.nativeContext, lastSeg, seg, {
            offsetX: offsetX,
            offsetY: offsetY
        }), context.setShadowBlendStyle && context.setShadowBlendStyle(line, attribute, defaultAttribute), 
        context.setStrokeStyle(line, attribute, offsetX, offsetY, defaultAttribute), context.stroke());
    }
}
//# sourceMappingURL=incremental-line-render.js.map
